<div class="snackbar-container">
  @for (notification of this.notifications(); track notification.id) {
    <div class="notification">
      <div class="content">
        <app-icon [icon]="notification.iconName" />
        <div class="notification-message">
          {{ notification.messageKey | translate }}
        </div>
      </div>
      <div>
        <button class="close-icon-btn" (click)="handleRemove(notification.id)">
          <app-icon class="close-icon" [icon]="IconName.CLOSE" />
        </button>
      </div>
    </div>
  }
</div>
